import { render, staticRenderFns } from "./SchoolPhones.vue?vue&type=template&id=6eefd430&"
import script from "./SchoolPhones.vue?vue&type=script&lang=js&"
export * from "./SchoolPhones.vue?vue&type=script&lang=js&"
import style0 from "./SchoolPhones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports